export enum LadingCareStatus {
    ChoXuLy= 1,
    DaXuLy = 2
}
